import React from "react"
import styles from "./Button.module.css"

const Button: React.FC<{
  color?: "primary" | "light" | "medium"
  fill?: "clear" | "solid"
  size?: "small" | "large" | "default"
  type?: "submit" | "reset" | "button"
  disabled?: boolean
  onClick?: (e: React.MouseEvent) => void
}> = ({ children, color, fill, onClick, size, type, disabled }) => {
  return (
    <button
      className={styles.button}
      data-color={color || "primary"}
      data-fill={fill || "solid"}
      data-size={size || "default"}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default Button
